import { SHOW_IMAGE_MODAL, HIDE_IMAGE_MODAL } from '../actions/image';

export const imageModal = (state = null, action) => {
  const { type, image } = action;
  if (type === SHOW_IMAGE_MODAL) {
    return image;
  }
  if (type === HIDE_IMAGE_MODAL) {
    return null;
  }

  return state;
};



// WEBPACK FOOTER //
// ./src/reducers/image.js